import { render, staticRenderFns } from "./QuoteFreightSectionEstimatesDisplay.vue?vue&type=template&id=72e0c381&scoped=true&"
import script from "./QuoteFreightSectionEstimatesDisplay.vue?vue&type=script&lang=ts&"
export * from "./QuoteFreightSectionEstimatesDisplay.vue?vue&type=script&lang=ts&"
import style0 from "./QuoteFreightSectionEstimatesDisplay.vue?vue&type=style&index=0&id=72e0c381&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e0c381",
  null
  
)

export default component.exports